import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {JsonPipe} from "@angular/common";

@Component({
    selector: 'app-request-location',
    templateUrl: './request-location.component.html',
    imports: [
        JsonPipe
    ],
    styleUrls: ['./request-location.component.scss']
})
export class RequestLocationComponent implements OnInit {
  @Input() content;
  @Output() sendLocation: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  sendLocationClick(event) {
    this.sendLocation.emit(event);
  }
}
